/* globals process */
import React from "react";
import { Affix, Alert } from "antd";
import * as R from "ramda";
import { css } from "glamor";
import { connect } from "react-refetch";

const affixStyle = css({
    top: 0,
    left: 0,
    width: "100%",
});

class StickyMessage extends React.Component {
    render() {
        const taskFetch = this.props.taskFetch;

        if (
            R.path(["value", "show_sticky_message"], taskFetch) &&
            taskFetch.value.message.length > 0
        ) {
            return (
                <Affix className={`${affixStyle}`}>
                    <Alert
                        message={taskFetch.value.message}
                        type={taskFetch.value.type}
                    />
                </Affix>
            );
        }

        return null;
    }
}

const Component =
    process.env.NODE_ENV !== "development"
        ? connect(props => {
              const source = props.source;

              return {
                  taskFetch: {
                      url: source,
                      method: "GET",
                      refreshInterval: 5000,
                      headers: {
                          pragma: "no-cache",
                          "cache-control": "no-cache",
                      },
                  },
              };
          })(StickyMessage)
        : () => null;

export default Component;
